import dateFunctions from '../../../../../utils/dateFunctions.js';
import NumberRounding from '../../../../../utils/numberRounding.js';
import campaignValues from '../../../../../utils/campaignValues.js';
import { CAMPAIGN_STATUS, CAMPAING_PROMISE_TYPES } from '../../../../../constants/enums.js';
import { PROMISE_TYPE_FIELDS } from '../types.js';

export class BaseExporter {
    constructor(orderline, deliveryData, countryCode, customer, orderId) {
        this.orderline = orderline;
        this.deliveryData = deliveryData;
        this.countryCode = countryCode;
        this.customer = customer;
        this.orderId = orderId;
        this.delivered = deliveryData?.orderLineDataInformation || {};
    }

    getDeliveryPercentage() {
        if (!this.deliveryData) return null;
        return NumberRounding.round(
            campaignValues.calculateDeliveryPercentageBasedOnPromise(
                [this.orderline],
                this.deliveryData
            ) * 100,
            0
        );
    }

    getCampaignStatus() {
        const status = campaignValues.campaignStatus(
            this.orderline.periodStart,
            this.orderline.periodEnd
        );
        return {
            [CAMPAIGN_STATUS.NOT_STARTED]: "Not started",
            [CAMPAIGN_STATUS.COMPLETED]: "Completed"
        }[status] || "Ongoing";
    }

    shouldIncludeProductName() {
        return campaignValues.fetchLocalParam5CampaignPromise(this.orderline.localParameter5) ===
            CAMPAING_PROMISE_TYPES.NO_AIRPORT_PLAYS_2_0_1;
    }

    getBaseData() {
        const deliveryPercentage = this.getDeliveryPercentage();
        return {
            Customer: this.customer,
            Campaign: this.orderline.alternativeName ||
                `${this.customer} w.${dateFunctions.calculateCampaignWeeks(this.orderline.periodStart, this.orderline.periodEnd)}`,
            'Product Type': campaignValues.productTypeDescription(this.countryCode, this.orderline.type),
            Product: this.orderline.product,
            ...(this.shouldIncludeProductName() ? { 'Product Name': this.orderline.name } : {}),
            Period: `w.${dateFunctions.calculateCampaignWeeks(this.orderline.periodStart, this.orderline.periodEnd)}`,
            'Product Promise': campaignValues.fetchPromiseUserFriendlyDescriptionBasedOnCampaignPromise(this.orderline.localParameter5),
            'Campaign status': this.getCampaignStatus(),
            'Delivery %': deliveryPercentage ? `${deliveryPercentage}%` : 'N/A',
            'OrderId': this.orderId,
            'OrderlineId': this.orderline.id
        };
    }

    getCampaignMetrics() {
        const isPlayCampaign = campaignValues.isPlayCampaign(this.orderline.type);
        return {
            estimatedEAVAC: isPlayCampaign ? this.orderline.targetVAC || 0 : this.orderline.postingTargetVac || 0,
            deliveredEAVAC: isPlayCampaign ? this.delivered.vacContacts || 0 : this.delivered.podPostingsSuccessfulVAC || 0,
            estimatedPanels: isPlayCampaign ? this.orderline.targetScreens || 0 : this.orderline.postingTarget || 0,
            deliveredPanels: isPlayCampaign ? this.delivered.screens || 0 : this.delivered.podPanelsDelivered || 0,
            estimatedPlays: isPlayCampaign ? this.orderline.targetPlays || 0 : 0,
            deliveredPlays: isPlayCampaign ? this.delivered.plays || 0 : 0,
        };
    }

    filterByPromiseType(exportData, baseData) {
        const campaignPromiseType = campaignValues.fetchLocalParam5CampaignPromise(this.orderline.localParameter5);
        const applicableFields = PROMISE_TYPE_FIELDS[campaignPromiseType] || [];

        return Object.fromEntries(
            Object.entries(exportData).map(([key, value]) => [
                key,
                baseData[key] || (applicableFields.includes(key) ? value : 'N/A')
            ])
        );
    }
}